export default __webpack_public_path__ + "static/media/service-management.6e59ebc6.svg";